// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center{margin-top:5px}.center .el-tabs__item{padding:0 60px;font-size:16px;color:#333;text-align:center}.center .el-tabs__item .is-active{color:#333}.center .el-tabs__item:hover{color:#0082f0}.center .el-tabs__active-bar{background-color:#0082f0}.el-tabs--top .el-tabs__item.is-top:nth-child(2){padding-left:20px!important}.el-tabs--top .el-tabs__item.is-top:last-child{padding-right:20px!important}.personForm .el-form-item__error{margin-left:100px}", ""]);
// Exports
module.exports = exports;
